import { useState, useEffect, useRef } from "react";

function getTimeLeft(target) {
  const diff = target - new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    expired: false,
  };
}

function pad(n) {
  return String(n).padStart(2, "0");
}

export const CountdownTimer = ({ targetDate, expiredMessage = null }) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(targetDate));
  const intervalRef = useRef(null);

  useEffect(() => {
    setTimeLeft(getTimeLeft(targetDate));
    intervalRef.current = setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [targetDate]);

  const { days, hours, minutes, seconds, expired } = timeLeft;

  const units = [
    { label: "Days", value: days },
    { label: "Hours", value: hours },
    { label: "Minutes", value: minutes },
    { label: "Seconds", value: seconds },
  ];

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", padding: "2rem 1rem" }}>
      {expired ? (
        <div
          style={{
            fontSize: 24,
            fontWeight: 500,
            lineHeight: 1.2,
            color: "var(--color-text-primary)",
            textAlign: "center",
          }}
        >
          {expiredMessage}
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: 12,
          }}
        >
          {units.map(({ label, value }) => (
            <div
              key={label}
              style={{
                background: "var(--color-background-secondary)",
                borderRadius: "var(--border-radius-lg)",
                padding: "1rem 0.5rem",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: 36,
                  fontWeight: 500,
                  lineHeight: 1.1,
                  fontVariantNumeric: "tabular-nums",
                  color: "var(--color-text-primary)",
                }}
              >
                {pad(value)}
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "var(--color-text-secondary)",
                  marginTop: 4,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                {label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CountdownTimer;
